import React, { useRef, useState, useEffect, forwardRef, Fragment, useImperativeHandle } from 'react';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from "react-router-dom";
import InviteCustomer1 from './NewWeddingHalls';
import InviteCustomer from './AddSupplier';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const CreatePurchaseOrder = forwardRef((props, ref) => {
    const [partModal, setPartModal] = useState(false);
    const [total, setTotal] = useState(0);
    const [finaltotal, setfinaltotal] = useState(0);
    const [errors, setErrors] = useState('')
    const userdata1 = localStorage.getItem('USER_data');
    const userData = JSON.parse(userdata1);
      const userid = userData.id;
    const [formData, setFormData] = useState({
        SupplierID: '',
        OrderDate: '',
        ExpectedDeliveryDate: '',
        TotalAmount: 0,
        Status: '',
        PaidBy: '',
        InvoiceNumber: '',
        DelPrice:'',
        AmountPaid:'',
        UserID: userid,
        TotalCost:'',
    });
    useImperativeHandle(ref, () => ({
        showPurchaseOrderModal() {
            fetchPartClasses();
            fetchSuppliersAndPartClasses()
            setPartModal(true);
        },
    }));
    const [purchaseOrderDetails, setPurchaseOrderDetails] = useState([]);
    const [selectedParts, setSelectedParts] = useState([]);
    const [expandedPartClassId, setExpandedPartClassId] = useState(null);
    const [parts, setParts] = useState([]); // Example array for parts data
    const [Discount, setDiscount] = useState(0);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleDetailChange = (index, e) => {
        const { name, value } = e.target;
        const updatedDetails = purchaseOrderDetails.map((detail, i) =>
            i === index ? { ...detail, [name]: value } : detail
        );
        setPurchaseOrderDetails(updatedDetails);
    };
    const handleInputChange2 = (e) => {
        const input = e.target.value;
    
        // Check if the input is a number or an empty string
        if (/^\d*$/.test(input)) {
          setDiscount(input);
          setfinaltotal((parseFloat(total) || 0)+(parseFloat(input) || 0));
          setFormData((prev) => ({
            ...prev,
            DelPrice: input // Corrected here
        }));

        // Update TotalAmount
       // const total = parseFloat(formData.TotalAmount) || 0; // Get current total amount
        const newTotalAmount = total + (parseFloat(input) || 0); // Calculate new total amount

        setFormData((prev) => ({
            ...prev,
            TotalAmount: newTotalAmount // Corrected here
        }));

        } else {
          setErrors("هده الخانه لاتقبل الا الاعداد الصحيحة")
    
        }
        setErrors('')
       }
    const addDetail = () => {
        setPurchaseOrderDetails((prev) => [...prev, { PartID: '', Quantity: 0, UnitPrice: 0 }]);
    };

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [formData1, setFormData1] = useState({
        categoryId: '', // Example form data structure
        serviceId: '',
    });







    //-------------------------part---------------------------
    const [partClasses, setPartClasses] = useState([]);


    const fetchPartClasses = async () => {
        try {
            const response = await axios.get('https://subk.education.com.ly/back/api/getPartClacess'); // Adjust your API URL
            setPartClasses(response.data);
        } catch (error) {
            console.error('Error fetching part classes:', error);
        }
    };


    // Fetch parts when a part class is selected


    // Handle part class selection
    const handlePartClassChange = async (partClass) => {
        const partClassId = partClass.PartClassID;

        // Toggle part class expansion
        if (expandedPartClassId === partClassId) {
            setExpandedPartClassId(null);
            setParts([]); // Clear parts if part class is collapsed
            //setSelectedParts([]); // Reset selected parts when collapsing
        } else {
            setExpandedPartClassId(partClassId);
            try {
                const response = await axios.get(`https://subk.education.com.ly/back/api/partclasses/${partClass.PartClassID}`); // Adjust your API URL
                setParts(response.data);
                console.log('response.data', response.data);
            } catch (error) {
                console.error('Error fetching parts:', error);
            }
        }
    };

    // Handle part selection (checkboxes)

    // Initial state for selected parts with quantity

    // Handle part selection

    const handlePartSelect1 = (part) => {
        setSelectedParts((prevSelectedParts) => {
            if (prevSelectedParts.some(selected => selected.PartID === part.PartID)) {
                // If part is already selected, remove it (similar to unchecking)
                return prevSelectedParts.filter(selected => selected.PartID !== part.PartID);
            } else {
                // If part is not selected, add it
                return [...prevSelectedParts, { PartID: part.PartID, quantity: 1, UnitPrice: formData.UnitPrice }];
            }
        });
    };

    // Function to remove a part (used by delete button in the table)
    const handleRemovePart = (partID) => {
        setSelectedParts((prevSelectedParts) =>
            prevSelectedParts.filter((selected) => selected.PartID !== partID)
        );
    };

    const handlePartSelect = (part) => {
        const partExists = selectedParts.some(selected => selected.PartID === part.PartID);

        if (partExists) {
            // If part is already selected, remove it from selectedParts
            setSelectedParts(selectedParts.filter(selected => selected.PartID !== part.PartID));
        } else {
            // Add the part with a default quantity of 1 and include UnitPrice
            setSelectedParts([...selectedParts, { ...part, quantity: 1, UnitPrice: 1 ,PurchasePrice :1|| 0 }]); // Initialize with part's UnitPrice
        }
    };
    const handleUnitPriceChange = (partID, unitPrice) => {
        setSelectedParts(
            selectedParts.map(selected =>
                selected.PartID === partID ? { ...selected, UnitPrice: parseFloat(unitPrice) } : selected
            )
        );
    };
    const handleUnitPriceChange1 = (partID, PurchasePrice) => {
        setSelectedParts(
            selectedParts.map(selected =>
                selected.PartID === partID ? { ...selected, PurchasePrice:parseFloat(PurchasePrice) } : selected
            )
        );

    };
    // Handle quantity change for a part
    const handleQuantityChange = (partID, quantity) => {
        setSelectedParts(
            selectedParts.map(selected =>
                selected.PartID === partID ? { ...selected, quantity: parseInt(quantity) } : selected
            )
        );
    };
    console.log(selectedParts)
    useEffect(() => {
        const newTotal = selectedParts.reduce((sum, part) => 
            sum + (part.quantity * part.UnitPrice), 0
        );
        setTotal(newTotal);
        setFormData((prev) => ({
            ...prev,
            TotalAmount: newTotal // Corrected here
        }));
        setFormData((prev) => ({
            ...prev,
            ReastAmount: newTotal // Corrected here
        }));
    }, [selectedParts]);
    const getunitQuantity = (partID) => {
        const selectedPart = selectedParts.find(selected => selected.PartID === partID);
        return selectedPart ? selectedPart.unitPrice : 1; // Default quantity is 1
    };
    // Get the quantity of a selected part
    const getPartQuantity = (partID) => {
        const selectedPart = selectedParts.find(selected => selected.PartID === partID);
        return selectedPart ? selectedPart.quantity : 1; // Default quantity is 1
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const purchaseOrderData = {
            ...formData,
            selectedParts,
        };
        try {
            const response = await fetch('https://subk.education.com.ly/back/api/purchaseorders', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(purchaseOrderData),
            });
            const result = await response.json();
            if (response.ok) {
                toast.success('تم الحفط بنجاح');

            } else {
                console.error('Error creating purchase order:', result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
        props.parentFunction();
        setPartModal(false)
    };

    const calculateTotalAmount = () => {
        return purchaseOrderDetails.reduce((total, detail) => {
            return total + (detail.Quantity * detail.UnitPrice);
        }, 0);
    };

    const [suppliers, setSuppliers] = useState([]);

    const fetchSuppliersAndPartClasses = async () => {
        try {
            // Fetch Suppliers
            const suppliersResponse = await axios.get('https://subk.education.com.ly/back/api/suppliers'); // Adjust your API endpoint
            setSuppliers(suppliersResponse.data);


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const invite1 = useRef();
    const invite = useRef();
     
    return (
        <>
            <Fragment>
                <Modal className="modal fade" size="xl" show={partModal} centered>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5">طلبية شراء</h1>
                            <button type="button" style={{ marginLeft: 0 }} className="btn-close" onClick={() => setPartModal(false)} ></button>
                        </div>
                        <form onSubmit={handleSubmit}>

                            <div className="modal-body">



                                <div className="row">
                                    {/* Supplier ID */}
                                  
                                    <div className="col-xl-3 d-flex">
                                        <label className="form-label m-1 ">المورد</label>
                                        <select required
                                            className="form-control"
                                            name="SupplierID"
                                            value={formData.SupplierID}
                                            onChange={handleChange}
                                            
                                        >
                                            <option value="">اختر</option>
                                            {suppliers.map(supplier => (
                                                <option key={supplier.SupplierID} value={supplier.SupplierID}>
                                                    {supplier.SupplierName}
                                                </option>
                                            ))}
                                        </select>
                                        < Link to={"#"} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                                   onClick={() => invite.current.showSupplierModal()}
                                > <i class="fa-solid fa-plus"></i></Link> 
                                       
                                    </div>

                                    {/* Order Date */}
                                    <div className="col-md-3 d-flex">
                                        <label className="form-label m-1" style={{ whiteSpace: "nowrap" }}>تاريخ الطلبية:</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="OrderDate"
                                            value={formData.OrderDate}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    {/* Expected Delivery Date */}



                                    {/* Paid Checkbox */}
                                    <div className="col-md-3 d-flex">
                                        <label className="form-label m-1" style={{ whiteSpace: "nowrap" }}>طريقة الدفع:</label>
                                        <select
                                            className="form-control"
                                            name="PaidBy"
                                            value={formData.PaidBy}
                                             onChange={(e) => setFormData({ ...formData, PaidBy: e.target.value })}
                                        >
                                            <option value="" >اختر</option>
                                            <option value="cash">كاش</option>
                                            <option value="card">بطاقة</option>
                                        </select>
                                    </div>



                                </div>
                                <div className="row">
                                    {/* Left Column for the Form */}
                                    <div className="row">
                                        <div className="col-xl-6 d-flex">
                                            <label className="form-label mt-4" style={{ whiteSpace: "nowrap" }}>اختر قطعة:</label>
                                            < Link to={"#"} className="btn btn-primary btn-sm pt-2 pb-2" style={{
                                                height: '30px',
                                                margin: '10px'
                                            }}
                                                onClick={() => invite1.current.showPartModal()}
                                            >  <i class="fa-solid fa-plus"></i> اضف قطع غيار </Link> {" "}
                                        </div>
                                        <div className="col-xl-6">
                                            <label className="form-label mt-4" style={{ whiteSpace: "nowrap" }}>القطع المختارة:</label>

                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                {/* Display part classes */}
                                                {partClasses.map(partClass => (
                                                    <div key={partClass.PartClassID}>
                                                        <div
                                                            onClick={() => handlePartClassChange(partClass)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                margin: '10px 0',
                                                                padding: '10px',
                                                                border: '1px solid #ccc',
                                                              //  background: expandedPartClassId === partClass.PartClassID ? 'rgb(37, 50, 78);' :' rgb(24, 34, 55)',
                                                            }}  
                                                        > <span style={{ marginleft: '10px' }}>
                                                        {expandedPartClassId === partClass.PartClassID ? '▲' : '▼'}
                                                    </span>
                                                            {partClass.PartClassName}
                                                        </div>
                                                        {expandedPartClassId === partClass.PartClassID && parts.length > 0 && (
                                                            <div style={{ padding: '10px', border: '1px solid #ccc', marginBottom: '10px' ,  backgroundColor:' #1c4c49'}}>
                                                                {parts.map(part => (
                                                                    <div
                                                                        key={part.PartID}
                                                                        className="part-details"
                                                                        style={{ margin: '5px 0', padding: '5px', border: '1px solid #ccc' ,

                                                                            background: selectedParts.some(selected => selected.PartID === part.PartID) ? '#d1e7dd' : '#fff', // Highlight selected service

                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedParts.some(selected => selected.PartID === part.PartID)}
                                                                            onChange={() => handlePartSelect(part)}
                                                                        />
                                                                        <strong style={{ marginLeft: '5px' }}>{part.PartName}</strong>

                                                                        {selectedParts.some(selected => selected.PartID === part.PartID) && (
                                                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                                                                <span style={{ marginLeft: '5px' }}> Quantity: {formData.Quantity}</span>

                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control"
                                                                                    value={getPartQuantity(part.PartID)}
                                                                                    onChange={(e) => handleQuantityChange(part.PartID, e.target.value)}
                                                                                    min="1"
                                                                                    style={{ width: '100px', marginRight: '10px' }}
                                                                                />
                                                                                <span style={{ marginLeft: '5px' }}>سعر الشراء:{formData.UnitPrice}</span>

                                                                                <input required
                                                                                    type="number"
                                                                                    value={formData.UnitPrice}
                                                                                    onChange={(e) => handleUnitPriceChange(part.PartID, e.target.value)}
                                                                                    min="0"
                                                                                    style={{ width: '80px', marginRight: '10px' }}
                                                                                />
                                                     <span style={{ marginLeft: '5px' }}>سعر البيع:{formData.PurchasePrice}</span>

                                                                                <input
required                                                                                    type="number"
                                                                                    value={formData.PurchasePrice}
                                                                                    onChange={(e) => handleUnitPriceChange1(part.PartID, e.target.value)}
                                                                                    min="0"
                                                                                    style={{ width: '80px', marginRight: '10px' }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}


                                            </div>
                                        </div>


                                        <div className="col-xl-6">
                                            <div className="table-responsive active-projects task-table my-2 mx-2" style={{ height: "200px" }}>
                                                <table className="table">
                                                     <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                                                        <tr>
                                                            <th>الصنف</th>
                                                            <th className="center">الكمية</th>
                                                            <th className="right">سعر القطعة</th>
                                                            <th className="right">المجموع</th>
                                                            <th className="right">حدف</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedParts.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                   لايوجد عنصر مختار
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            selectedParts.map((item, ind) => (
                                                                <tr key={item.PartID}>
                                                                    <td>{item.PartName}</td>

                                                                    <td contentEditable
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();  // Prevents a new line in the contentEditable cell
                                                                                handleQuantityChange(item.PartID, e.target.textContent);
                                                                                e.target.blur();  // Optionally removes focus from the cell after pressing Enter
                                                                            }
                                                                        }}										>{item.quantity}



                                                                    </td>
                                                                    <td contentEditable
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();  // Prevents a new line in the contentEditable cell
                                                                                handleUnitPriceChange(item.PartID, e.target.textContent);
                                                                                e.target.blur();  // Optionally removes focus from the cell after pressing Enter
                                                                            }
                                                                        }}>{item.UnitPrice} </td>
                                                                    <td className="right">{((Number(item.quantity)) * (Number(item.UnitPrice) || 0)).toFixed(2)} د</td>
                                                                    <td ><Link onClick={() => handleRemovePart(item.PartID)}><i class="fas fa-trash-alt m-2 me-3"></i></Link>						</td>			</tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="input-group" style={{ direction: "ltr" }}>
                          <input type="text" style={{ direction: "ltr", borderTopRightRadius: '0',
  borderBottomRightRadius: '0',
  height: '2.5rem '}}
                            value={Discount}
                            onChange={handleInputChange2}
                            name="DiscountAmount"
                            
                            className="form-control" ></input>

                          <button type="" className="input-group-text" >خدمة التوصيل</button>
                        </div>
                        {errors ? <div className=' alert alert-danger'>{errors}</div> : ""}
                     <table className="table table-clear">
                          <tbody>
                            <tr>
                              <td className="left">
                                <strong>الحسابى الكلي</strong>
                              </td>
                              <td className="right">{total}د</td>
                            </tr>
                            
                            <tr>
                              <td className="left">
                                <strong>خدمة توصيل</strong>
                              </td>
                              <td className="right">{Discount}د</td>
                            </tr>
                           
                            <tr>
                              <td className="left">
                                <strong>الحسابى النهائي</strong>
                              </td>
                              <td className="right">
                                <strong>{finaltotal}د</strong>
                                <br />
                              </td>
                            </tr>
                          </tbody>
                        </table> 
                         <div className="input-group" style={{ direction: "ltr" }}>
                         <input type="text" style={{ direction: "ltr", borderTopRightRadius: '0',
  borderBottomRightRadius: '0',
  height: '2.5rem '}}
                            value={formData.AmountPaid}
                            onChange={handleChange}
                            name="AmountPaid"
                            required
                            className="form-control" ></input>

                        <button type="" className="input-group-text" >المدفوع</button>
                        </div> 
                        {errors ? <div className=' alert alert-danger'>{errors}</div> : ""}
                                        </div>
                                    </div>

                                </div>   </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">حفظ</button>
                                <button
                                    type="button"
                                    className="btn btn-danger light"
                                    onClick={() => setPartModal(false)}
                                >
                                    الغاء
                                </button>
                                
                            </div>
                        </form>
                    </div>

                </Modal>
            </Fragment>
            <InviteCustomer1
                ref={invite1}
            parentFunction={fetchPartClasses}  
            //inviteModal={inviteModal}
            />
             <InviteCustomer
                ref={invite}
                parentFunction={fetchSuppliersAndPartClasses}  

            //parentFunction={fetchProducts}  
            //inviteModal={inviteModal}
            />
             </>
    );
});

export default CreatePurchaseOrder;
